var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _concatInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/concat");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs3/core-js/instance/concat"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs3/core-js/instance/concat"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, _concatInstanceProperty2(global));
    global.constant = mod.exports;
  }
})(this, function (_exports, _concat) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.DEFAULT_CONFIG = _exports.JS_TRACKER_ERROR_DISPLAY_MAP = _exports.JS_TRACKER_ERROR_CONSTANT_MAP = _exports.ALLOWED_KEYS = _exports.BEHAVIOR_TYPES_MAP = _exports.LOG_TYPE_PERFORMANCE = _exports.LOG_TYPE_INFO = _exports.LOG_TYPE_PRODUCT = _exports.LOG_TYPE_ERROR = _exports.TEST_FLAG = _exports.TARGET = _exports.COOKIE_NAME_DIVICE_ID = void 0;
  _concat = _interopRequireDefault(_concat);
  var COOKIE_NAME_DIVICE_ID = 'crosSdkDT2019DeviceId';
  _exports.COOKIE_NAME_DIVICE_ID = COOKIE_NAME_DIVICE_ID;
  var TARGET = 'https://dig.lianjia.com/fee.gif'; // pid string 工程id:platfe_saas
  // uuid string 用户信息
  // ucid string 用户信息
  // ssid string 用户信息
  // mac string mac地址
  // 测试标记符

  _exports.TARGET = TARGET;
  var TEST_FLAG = 'b47ca710747e96f1c523ebab8022c19e9abaa56b';
  _exports.TEST_FLAG = TEST_FLAG;
  var LOG_TYPE_ERROR = 'error'; // 错误日志

  _exports.LOG_TYPE_ERROR = LOG_TYPE_ERROR;
  var LOG_TYPE_PRODUCT = 'product'; // 产品指标

  _exports.LOG_TYPE_PRODUCT = LOG_TYPE_PRODUCT;
  var LOG_TYPE_INFO = 'info'; // 尚未使用

  _exports.LOG_TYPE_INFO = LOG_TYPE_INFO;
  var LOG_TYPE_PERFORMANCE = 'perf'; // 性能指标

  _exports.LOG_TYPE_PERFORMANCE = LOG_TYPE_PERFORMANCE;
  var BEHAVIOR_TYPES_MAP = {
    BEHAVIOR_TYPES_CLICK: 'click',
    BEHAVIOR_TYPES_API: 'api',
    BEHAVIOR_TYPES_LOAD: 'load',
    BEHAVIOR_TYPES_NAV: 'nav'
  }; // 允许业务自定义上报的字段，以及字段长度

  _exports.BEHAVIOR_TYPES_MAP = BEHAVIOR_TYPES_MAP;
  var ALLOWED_KEYS = {
    msg: 30
  }; // 定义JS_TRACKER错误类型码

  _exports.ALLOWED_KEYS = ALLOWED_KEYS;
  var JS_TRACKER_ERROR_CONSTANT_MAP = {
    1: 'ERROR_RUNTIME',
    2: 'ERROR_SCRIPT',
    3: 'ERROR_STYLE',
    4: 'ERROR_IMAGE',
    5: 'ERROR_AUDIO',
    6: 'ERROR_VIDEO',
    7: 'ERROR_CONSOLE',
    8: 'ERROR_TRY_CATCH',
    9: 'ERROR_UNHANDLED_REJECTION'
  };
  _exports.JS_TRACKER_ERROR_CONSTANT_MAP = JS_TRACKER_ERROR_CONSTANT_MAP;
  var JS_TRACKER_ERROR_DISPLAY_MAP = {
    1: 'JS_RUNTIME_ERROR',
    2: 'SCRIPT_LOAD_ERROR',
    3: 'CSS_LOAD_ERROR',
    4: 'IMAGE_LOAD_ERROR',
    5: 'AUDIO_LOAD_ERROR',
    6: 'VIDEO_LOAD_ERROR',
    7: 'CONSOLE_ERROR',
    8: 'TRY_CATCH_ERROR',
    9: 'UNHANDLED_REJECTION_ERROR'
  }; // 默认配置

  _exports.JS_TRACKER_ERROR_DISPLAY_MAP = JS_TRACKER_ERROR_DISPLAY_MAP;
  var DEFAULT_CONFIG = {
    pid: '',
    // [必填]项目id, 由灯塔项目组统一分配
    uuid: '',
    // [可选]设备唯一id, 默认由sdk自动生成. 用于计算uv数&设备分布.
    ucid: '',
    // [可选]用户ucid, 用于发生异常时追踪用户信息, 一般在cookie中可以取到, 没有可传空字符串
    is_test: false,
    // 是否为测试数据, 默认为false(测试模式下打点数据仅供浏览, 不会展示在系统中)
    record: {
      spa: false,
      record_operation: false,
      // 是否记录用户操作 toC应用禁止打开此开关，涉及用户隐私问题
      // behavior_queue_size: 10, // 记录用户操作数的最大值，默认10，最大30
      time_on_page: true,
      // 是否监控用户在线时长数据, 默认为true
      performance: true,
      // 是否监控页面载入性能, 默认为true
      js_error: true,
      //  是否监控页面报错信息, 默认为true
      // 配置需要监控的页面报错类别, 仅在js_error为true时生效, 默认均为true(可以将配置改为false, 以屏蔽不需要上报的错误类别)
      js_error_report_config: {
        ERROR_RUNTIME: true,
        // js运行时报错
        ERROR_SCRIPT: true,
        // js资源加载失败
        ERROR_STYLE: true,
        // css资源加载失败
        ERROR_IMAGE: true,
        // 图片资源加载失败
        ERROR_AUDIO: true,
        // 音频资源加载失败
        ERROR_VIDEO: true,
        // 视频资源加载失败
        ERROR_CONSOLE: true,
        // vue运行时报错
        ERROR_TRY_CATCH: true,
        // 未catch错误
        // 自定义检测函数, 判断是否需要报告该错误
        checkErrorNeedReport: function checkErrorNeedReport() {
          var desc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          var stack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
          var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
          var reason = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
          return true;
        }
      },
      // 监控接口请求配置
      api_report_config: {
        enable: true,
        withBody: false,
        withResp: false,
        sampleRate: 1,

        /* params 格式
          {
            url: '', // api url，
            status: 200, // http status
            response: '' // API请求的body内容
          }
        */
        reportFilter: function reportFilter(param) {
          var customParams = param; // 返回值可以是 false 或者 Object 对象。返回false 则此次api数据直接丢弃

          return customParams;
        }
      }
    },
    // 业务方的js版本号, 会随着打点数据一起上传, 方便区分数据来源
    // 可以不填, 默认为1.0.0
    version: '1.0.0',
    // 对于如同
    // xxx.com/detail/1.html
    // xxx.com/detail/2.html
    // xxx.com/detail/3.html
    // ...
    // 这种页面来说, 虽然url不同, 但他们本质上是同一个页面
    // 因此需要业务方传入一个处理函数, 根据当前url解析出真实的页面类型(例如: 二手房列表/经纪人详情页), 以便灯塔系统对错误来源进行分类
    // getPageType函数执行时会被传入一个location对象, 业务方需要完成该函数, 返回对应的的页面类型(50字以内, 建议返回汉字, 方便查看), 默认是返回当前页面的url
    getPageType: function getPageType() {
      var _context;

      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;
      return (0, _concat.default)(_context = "".concat(location.host)).call(_context, location.pathname);
    }
  };
  _exports.DEFAULT_CONFIG = DEFAULT_CONFIG;
});